export class Login {
  public  id?: number | 0;
  public   password?:string | "";
  public currentPassword?:string |"";
}
